export const environment = {
  production: false,
  api_url: 'https://apolo.genxapp.co/api',
  // api_url: 'http://localhost:8080/api',
};
